import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;

if (!secretKey || secretKey.length !== 32) {
  console.log("The encryption key must be a 32-character string.");
}

const iv = CryptoJS.enc.Utf8.parse(secretKey.substr(0, 16));

export const aesEncrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    data,
    CryptoJS.enc.Utf8.parse(secretKey),
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString();
};

export const aesDecrypt = (encryptedData) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(
      encryptedData,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const result = decrypted.toString(CryptoJS.enc.Utf8);
    if (!result) {
      return null;
    }
    return result;
  } catch (error) {
    return null;
  }
};
